import Link from "next/link";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUndoAlt, faHome } from "@fortawesome/pro-solid-svg-icons";

export const ResetForm = ({
    cancelUrl,
    idPrefix,
    showReset = true,
    showHome = true,
    color = "text-alt-dark-grey half-here",
}: {
    cancelUrl: string;
    idPrefix: string;
    showReset?: boolean;
    showHome?: boolean;
    color?: string;
}) => (
    <div className="full-width text-center m-b-spacer-3xl flex flex-justify-center">
        {showReset ? (
            <div className="m-r-spacer-md">
                <Link href={cancelUrl || "#"}>
                    <a id={`${idPrefix}-restart`} className={color}>
                        <FontAwesomeIcon icon={faUndoAlt} />
                        <div className="ec-primary-font half-here font-size-14">
                            Restart
                        </div>
                    </a>
                </Link>
            </div>
        ) : null}

        {showHome ? (
            <div className="m-l-spacer-md">
                <Link href="/">
                    <a id={`${idPrefix}-home`} className={color}>
                        <FontAwesomeIcon icon={faHome} />
                        <div className="ec-primary-font half-here font-size-14">
                            Home
                        </div>
                    </a>
                </Link>
            </div>
        ) : null}
    </div>
);
